import Circle from 'ol/geom/Circle';
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { arrondir } from '../librairie';



function Popup({ pointsurvolle,theme1,theme2,theme3,cercleproportionnel }) {

    const [donnees, setDonnees] = useState(null);

    const Affichage = (donnees) => {
        return <>
            {donnees.donnees && donnees.donnees.nbre4 ?
                <li className='contenupopup'>{cercleproportionnel.nomafficher.replace('$$',cercleproportionnel.annee)} <b>{arrondir(donnees.donnees.nbre4)} {cercleproportionnel.unite}</b></li>
                :
                null
            }
            {donnees.donnees && donnees.donnees.nbre1 ?
                <li className='contenupopup'>{theme1.nomafficher.replace('$$',theme1.annee)} <b>{arrondir(donnees.donnees.nbre1)} {theme1.unite}</b></li>
                :
                null
            }
            {donnees.donnees && donnees.donnees.nbre2 ?
                <li className='contenupopup'>{theme2.nomafficher.replace('$$',theme2.annee)} <b>{arrondir(donnees.donnees.nbre2)} {theme2.unite}</b></li>
                :
                null
            }
            {donnees.donnees && donnees.donnees.nbre3 ?
                <li className='contenupopup'>{theme3.nomafficher.replace('$$',theme3.annee)} <b>{arrondir(donnees.donnees.nbre3)} {theme3.unite}</b></li>
                :
                null
            }
        </>
    }

    useEffect(() => {

        if (pointsurvolle) {
            pointsurvolle.forEach(element => {
                if (element.getProperties().geometry instanceof Circle) {
                    setDonnees(element.getProperties());
                }

            });
        }

    }, [pointsurvolle])
    return (
        <div id="popup-content"><Affichage donnees={donnees} /></div>
    )
}

function mapStateToProps(state) {
	return {
		theme1: state.theme1,
		theme2: state.theme2,
		theme3: state.theme3,
		cercleproportionnel: state.cercleproportionnel,
	}
}


export default connect(mapStateToProps)(Popup);